module.exports = __webpack_public_path__ + "media/icons/mailing-instagram@3x-a21ade2f.svg";